import { FileListData } from '@typings/ResidentTypes';

export const hasMCAOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  {
    value: 'no',
    label: 'No',
  },
  {
    value: 'notSure',
    label: 'Not Sure',
  },
];

export interface MentalCapacityAssessmentType {
  hasAssessment: string;
  dateCompleted: { day: string; month: string; year: string };
  capacityAssessmentEntry: string;
  locationOfMca: string;
  mcaFormList: FileListData[];
}
